export const formatPrice = (value: number | undefined | null): string => {
  if (!value && value !== 0) return '0.00';
  return value.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatCurrencyStatistic = (value: number | string): string => {
  const parsedValue = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(parsedValue)) return '$0.00';
  return `$${formatPrice(parsedValue)}`;
};

export const formatSumaAsegurada = (suma: string, valorVehiculo?: number): string => {
  if (!suma || suma === '0') return 'Valor comercial';
  const match = suma.replace(/,/g, '').match(/[\d.]+/);
  if (!match) return suma;
  const numValue = parseFloat(match[0]);
  if (isNaN(numValue)) return suma;
  if (valorVehiculo && Math.abs(numValue - valorVehiculo) < 1) {
    return `Valor comercial ($${numValue.toLocaleString('es-MX')})`;
  }
  if (numValue >= 1000000) return `${(numValue / 1000000).toFixed(0).replace(/\.0$/, '')},000,000`;
  return numValue.toLocaleString('es-MX');
};
